/**
 * Returns true if the given object is a boolean. No type conversion will be performed.
 */
export function isBoolean(pObj) {
    return (typeof pObj === "boolean" || pObj instanceof Boolean);
}
